import { FC, useState } from "react"

import StatsPanel from "../../../stats/panel"
import StatsSegmented from "../../../stats/segmented"
import RateAlertsTable from "./table/rate-alerts"
import IntroTable from "./table/intro"
import QuoteReceiptTable from "./table/quote-receipt"
import UnsubscribedTable from "./table/unsubscribed"

export enum EmailStatsTabs {
  RATE_ALERTS = "by-rate-alerts",
  INTRO_EMAILS = "by-intro-emails",
  UNSUBSCRIBED = "by-unsubscribed",
  QUOTE_RECEIPT = "by-quote-receipt"
}

const EMAIL_TYPE_OPTIONS: { value: EmailStatsTabs; label: string }[] = [
  { value: EmailStatsTabs.RATE_ALERTS, label: "Rate alerts" },
  { value: EmailStatsTabs.INTRO_EMAILS, label: "Intro emails" },
  { value: EmailStatsTabs.QUOTE_RECEIPT, label: "Quote receipts" },
  { value: EmailStatsTabs.UNSUBSCRIBED, label: "Unsubscribed" }
]

interface EmailStatsProps {
  title: string
  range: number
  orgId: string | undefined
  loid: string | undefined
}

const EmailStats: FC<EmailStatsProps> = ({ title, range, orgId, loid }) => {
  const [tab, setTab] = useState<EmailStatsTabs>(EmailStatsTabs.RATE_ALERTS)

  return (
    <StatsPanel
      title={title}
      description="Sends, opens and unsubscribes for each kind of email you send"
      actions={
        <StatsSegmented
          label="Email type"
          options={EMAIL_TYPE_OPTIONS}
          value={tab}
          onChange={setTab}
        />
      }
    >
      {tab === EmailStatsTabs.RATE_ALERTS && (
        <RateAlertsTable range={range} orgId={orgId} loid={loid} />
      )}
      {tab === EmailStatsTabs.INTRO_EMAILS && (
        <IntroTable range={range} orgId={orgId} loid={loid} />
      )}
      {tab === EmailStatsTabs.QUOTE_RECEIPT && (
        <QuoteReceiptTable range={range} orgId={orgId} loid={loid} />
      )}
      {tab === EmailStatsTabs.UNSUBSCRIBED && (
        <UnsubscribedTable range={range} orgId={orgId} loid={loid} />
      )}
    </StatsPanel>
  )
}

export default EmailStats
